// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Sm_T","rootMobile":"styles_rootMobile__3lVt3"};